/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Addopportunityowner_Modal_Addbutton4Inputs */

const en_coinvestments_addopportunityowner_modal_addbutton4 = /** @type {(inputs: Coinvestments_Addopportunityowner_Modal_Addbutton4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit`)
};

/**
* | output |
* | --- |
* | "Submit" |
*
* @param {Coinvestments_Addopportunityowner_Modal_Addbutton4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_addopportunityowner_modal_addbutton4 = /** @type {((inputs?: Coinvestments_Addopportunityowner_Modal_Addbutton4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Addopportunityowner_Modal_Addbutton4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_addopportunityowner_modal_addbutton4(inputs)
});
export { coinvestments_addopportunityowner_modal_addbutton4 as "coInvestments_addOpportunityOwner_modal_addButton" }